import store from '@/store';

export default (to, from, next) => {
    const is_sim_settings_allowed = store.getters.is_sim_settings_allowed;

    return {
        allow: is_sim_settings_allowed,
        redirect: { name: 'not-found' },
    }
};